/* eslint-disable hubspot-dev/no-private-classes */
export const protectedDocs = {
  'Developers:UnifiedApps:PrivateBeta': {
    'en-us': {
      'guides/developer-platform': ['app-configuration', 'build-with-config-profiles', 'features/app-objects/quickstart-guide-to-app-objects', 'features/app-objects/reference', 'features/configure-webhooks', 'features/create-a-settings-component', 'features/create-an-app-card', 'features/custom-workflow-actions', 'features/marketplace/set-up-demo-scheduling-from-the-app-listing-page', 'features/marketplace/view-contacts-created-from-the-marketplace', 'manage-apps-in-hubspot', 'migrate-an-app/migrate-an-existing-private-app', 'migrate-an-app/migrate-an-existing-public-app', 'overview', 'quickstart-guide']
    }
  },
  'AIAgent:AIStudio': {
    'en-us': {
      'guides/developer-platform': ['features/agent-tools/create-an-agent-tool', 'features/agent-tools/overview', 'features/agent-tools/reference', 'features/marketplace/agent-tool-listing-requirements']
    }
  }
};